<ng-template #stepLogin>
  <app-login (changeStepStatus)="fetchPhone($event)" [form]="loginForm"></app-login>
</ng-template>

<ng-template #stepCode>
  <app-enter-code [isResetPassword]="false" [phone]="loginForm.get('login').value" (changeStep)="changeStep($event)" (putToken)="putToken($event)"></app-enter-code>
</ng-template>

<ng-template #stepAuthorization>
  <app-authorization [phone]="loginForm.get('login').value" (changeStep)="changeStep($event)"></app-authorization>
</ng-template>

<ng-template #stepRegistration>
  <app-registration [token]="token" [login]="loginForm.get('login').value" (changeStep)="changeStep($event)"></app-registration>
</ng-template>

<ng-template #stepResetPassword>
  <app-reset-password [login]="loginForm.get('login').value" (changeStepStatus)="changeStep($event)"></app-reset-password>
</ng-template>

<ng-template #stepConfirmResetPassword>
  <app-enter-code [isResetPassword]="true" [phone]="loginForm.get('login').value" (changeStep)="changeStep($event)" (putToken)="putToken($event)"></app-enter-code>
</ng-template>

<ng-template #stepCreateNewPassword>
  <app-create-new-password [token]="token" [login]="loginForm.get('login').value" (closePassSetup)="changeStep($event)"></app-create-new-password>
</ng-template>

<app-panel [header]="titleSteps[currentlyStep]" [template]="steps[currentlyStep]" [visible]="openPanel" (visibleChange)="visibleChange($event)"></app-panel>